import React from 'react'

export default (props) => {
  return (
    <svg width="17px" height="16px" viewBox="0 0 17 16" {...props}>
      <g id="全家桶视觉方案优化" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="工作台1" transform="translate(-754.000000, -299.000000)">
          <g id="分组-6" transform="translate(240.000000, 96.000000)">
            <g id="编组-18" transform="translate(0.000000, 171.000000)">
              <g id="复制成功" transform="translate(514.500000, 32.000000)">
                <rect
                  id="矩形"
                  fillOpacity="0.01"
                  fill="#FFFFFF"
                  fillRule="nonzero"
                  x="0"
                  y="0"
                  width="16"
                  height="16"
                ></rect>
                <polyline
                  id="路径"
                  stroke="#07C790"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  points="14.3333333 3.66666667 5.625 12.3333333 1.66666667 8.39393333"
                ></polyline>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
